import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import BootstrapVue from 'bootstrap-vue'
import axios from '@/axios'
import VueMoment from 'vue-moment'
import Notify from 'vue2-notify'
import VueImgPreview from '@duoa/vue-img-preview'
import Toast from 'vue-toastification';
import VueProgressBar from 'vue-progressbar'
import VueGtag from 'vue-gtag'
import VueFacebookPixel from 'vue-facebook-pixel'
import './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@duoa/vue-img-preview/dist/vue-img-preview.css';
import 'vue-toastification/dist/index.css';
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueMoment);
Vue.use(Notify, {
  position: 'bottom-full',
  itemClass: 'alert col col-md-6 offset-md-3 col-xl-4 offset-xl-4',
  enter: 'fadeIn',
  leave: 'fadeOut',
  visibility: 5000,
});
Vue.use(VueImgPreview, {
  zIndex: 9999
});
Vue.prototype.$http = axios;
Vue.use(Toast, {
  position: "bottom-center",
  timeout: false,
  closeOnClick: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
});
Vue.use(VueProgressBar, {
  color: '#34bfa3',
  failedColor: '#e0324f',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})
Vue.use(VueGtag, {
  bootstrap: false,
  pageTrackerTemplate(to) {
    const titleElement = document.querySelector('h1.m-subheader__title');

    return {
      page_title: titleElement ? titleElement.innerHTML : to.name,
      page_path: to.path,
      page_location: window.location.href
    }
  },
}, router);
Vue.use(VueFacebookPixel, {
  router,
  debug: process.env.NODE_ENV !== 'production'
});
Vue.component(VueQrcode.name, VueQrcode);

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

require('@/assets/vendors/base/vendors.bundle.css');
require('@/assets/demo/default/base/style.bundle.css');
require('@/components/input/vue-tagsinput/dist/style.css');
